export const fileList = [
    {
        name: "图片",
        key: "imageUrls",
    },

];
